import {formatDistanceToNow} from "date-fns";

const MILLIS_PER_SECOND = 1000;
const MILLIS_PER_MINUTE = MILLIS_PER_SECOND * 60;
const MILLIS_PER_HOUR = MILLIS_PER_MINUTE * 60;

function millisToHoursMinutesSeconds(millis: number) {
    const wholeHours = Math.floor(millis / MILLIS_PER_HOUR);

    const minuteMillis = millis - wholeHours * MILLIS_PER_HOUR;
    const wholeMinutes = Math.floor(minuteMillis / MILLIS_PER_MINUTE);

    const secondMillis = minuteMillis - wholeMinutes * MILLIS_PER_MINUTE;
    const wholeSeconds = Math.floor(secondMillis / MILLIS_PER_SECOND);

    return [wholeHours, wholeMinutes, wholeSeconds];
}

export function stringifyVideoTimeWithColons(millis: number, alwaysShowHours?: true) {
    const [hours, minutes, seconds] = millisToHoursMinutesSeconds(millis);

    const hourString = hours < 10 ? `0${hours}` : `${minutes}`;
    const minuteString = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const secondString = seconds < 10 ? `0${seconds}` : `${seconds}`;

    const showHours = hours > 0 || alwaysShowHours;

    return showHours
        ? [hourString, minuteString, secondString].join(":")
        : [minuteString, secondString].join(":");
}

export function stringifyVideoTimeWithLetters(millis: number) {
    const [hours, minutes, seconds] = millisToHoursMinutesSeconds(millis);

    return hours > 0
        ? `${hours}h${minutes}m${seconds}s`
        : `${minutes}m${seconds}s`;
}

export function stringifyVideoTimeAgo(when: Date) {
    return formatDistanceToNow(when, {addSuffix: true}).replace(/about /, "");
}

const HR_MIN_SEC_PATTERN = /^(\d+)h(\d+)m(\d+)s$/;
const MIN_SEC_PATTERN = /^(\d+)m(\d+)s$/;
const SEC_PATTERN = /^(\d+)s$/;

export function timestampStringToSeconds(timestamp: string): number | null {
    let hours, minutes, seconds;

    if (timestamp.includes("h")) {
        const match = HR_MIN_SEC_PATTERN.exec(timestamp);

        if (!match) {
            return null;
        }

        const [, hourString, minuteString, secondString] = match;

        hours = parseInt(hourString, 10);
        minutes = parseInt(minuteString, 10);
        seconds = parseInt(secondString, 10);
    } else if (timestamp.includes("m")) {
        const match = MIN_SEC_PATTERN.exec(timestamp);

        if (!match) {
            return null;
        }

        const [, minuteString, secondString] = match;

        hours = 0;
        minutes = parseInt(minuteString, 10);
        seconds = parseInt(secondString, 10);
    } else {
        const match = SEC_PATTERN.exec(timestamp);

        if (!match) {
            return null;
        }

        const [, secondString] = match;

        hours = 0;
        minutes = 0;
        seconds = parseInt(secondString, 10);
    }

    return (hours * 60 * 60) + (minutes * 60) + seconds;
}
